import React, { ReactNode } from "react"
import { motion } from "framer-motion"

interface PageHeroProps {
  title: string
  description: string
  backgroundImage: string
  backgroundAlt?: string
  children?: ReactNode
}

export function PageHero({
  title,
  description,
  backgroundImage,
  backgroundAlt = "Background image",
  children
}: PageHeroProps) {
  return (
    <section className="relative pt-32 pb-24 overflow-hidden min-h-[600px] flex items-center">
      <div className="absolute inset-0 z-0 bg-background">
        <div className="relative w-full h-full">
          <img
            src={backgroundImage}
            alt={backgroundAlt}
            className="object-cover hero-bg w-full h-full"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background/70 to-background" />
        </div>
      </div>
      
      <div className="container relative z-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center space-y-6 pt-8"
        >
          <h1
            className="text-2xl font-light tracking-tight sm:text-3xl md:text-4xl lg:text-5xl text-foreground/90 leading-tight"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <p className="text-xl text-muted-foreground font-light">
            {description}
          </p>
          {children}
        </motion.div>
      </div>
    </section>
  )
} 